module.exports = __webpack_public_path__ + "static/media/aura.7cdc8800.png";